import {RequestAxios} from "../../index";
import {PersonnelProfile} from "./interfaces";
import {API_START} from "../../constants";

export const getPersonnelProfile = async (id: number) => {
    const personnelGuIdUrl = `${API_START}/clients/personnel/${id}/profile`;
    return await RequestAxios.get<PersonnelProfile>(personnelGuIdUrl)
}